export default __webpack_public_path__ + "static/media/bg_doixe.e5977fbf.svg";